{
  "title": "Configuración",
  "description": "Gestiona tu cuenta, seguridad y preferencias.",
  "sectionsHeading": "Configuración",
  "appearanceHeading": "Apariencia",
  "appearanceDescription": "Elige cómo se ve la aplicación. Tu tema se guarda en este dispositivo.",
  "rows": {
    "profile": {
      "title": "Perfil",
      "description": "Actualiza tu nombre, correo y datos personales."
    },
    "security": {
      "title": "Seguridad",
      "description": "Gestiona tu contraseña, la verificación en dos pasos y las sesiones."
    },
    "notifications": {
      "title": "Notificaciones",
      "description": "Elige cómo y cuándo te contactamos."
    },
    "privacy": {
      "title": "Privacidad",
      "description": "Gestiona el consentimiento, la exportación de datos y la eliminación de la cuenta."
    },
    "billing": {
      "title": "Facturación",
      "description": "Consulta tu plan, tus facturas y tus datos de pago."
    }
  }
}
